import { TableCell as MuiTableCell, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
// import { PALETTE } from "@fedsim/constants";

const TableCell = styled(MuiTableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: PALETTE.HIGHLIGHT,
    // color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

export const StyledTableCell = TableCell;

export const StyledTableRow = TableRow;
